import styled from "styled-components";

const Img = styled.img`
box-shadow:0px 0px 5px 1px rgba(0,0,0,0.3);
`;

export default Img;
